import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";


const firebaseConfig = {
    apiKey: "AIzaSyCqX1hL-FpUJLASVfzZ88hS7UKxF0g5wLI",
    authDomain: "frinple-web-app.firebaseapp.com",
    projectId: "frinple-web-app",
    storageBucket: "frinple-web-app.appspot.com",
    messagingSenderId: "262966879130",
    appId: "1:262966879130:web:d8d2384999e10cd77c9023"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const handleNotificationGranted = () => {

    navigator.serviceWorker.register(sw).then(registration => {

        getToken(messaging, {
            serviceWorkerRegistration: registration,
            vapidKey: 'BOtuuRHGnFKnw6x5_XpNvoO2P2Veax2gI540LS6t2vxN07kohLrpnuQqdEuZvx1E6f2LYTqvhkFPzx4S-EV1mk0' }).then((currentToken) => {
            if (currentToken) {

                axios.post('push-notifications/store/token', { token: currentToken } );

                console.log(currentToken);
            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });

    });

}


if (Notification.permission !== 'granted') {

    Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
            handleNotificationGranted();
        } else {
            console.error('Permissão de notificação negada.');
        }
    });

} else {
    handleNotificationGranted();
}



